import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { MainLoaderComponent } from './main-loader.component';
@NgModule({
  imports: [
    IonicModule,
  ],
  exports: [MainLoaderComponent],
  declarations: [MainLoaderComponent],
  providers: [],
})
export class MainLoaderModule {
}
